import React from "react";
import type { ISvgProps } from "components/icons/shared_props";

import { MAIN_THEME } from "styles/theme";

export default function LeftArrowIcon({
  size = "24",
  color = MAIN_THEME.colors.brandWhite,
}: ISvgProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size}>
      <path fill="none" d="M0 0h24v24H0z" />
      <path
        fill={color}
        d="M22 11H6.414l2.293-2.293-1.414-1.414L2.586 12l4.707 4.707 1.414-1.414L6.414 13H22z"
      />
    </svg>
  );
}
